export default {
  data: function data() {
    return {
      // 分页
      pagination: {
        current: 1,
        size: 10,
        total: 0
      }
    };
  },
  computed: {
    // 为搜索参数提供数据
    paginationSearchData: function paginationSearchData() {
      return {
        page: this.pagination.current,
        page_size: this.pagination.size
      };
    },
    // vNode
    // 小型分页
    vNodePaginationMini: function vNodePaginationMini() {
      var _this = this;

      var h = this.$createElement;
      var node = h("el-pagination", {
        "attrs": {
          "layout": "prev, pager, next",
          "current-page": this.pagination.current,
          "page-size": this.pagination.size,
          "total": this.pagination.total,
          "pager-count": 5,
          "small": true
        },
        "on": {
          "current-change": function currentChange(current) {
            _this.pagination.current = current;

            _this.research();
          }
        }
      });
      return node;
    },
    // vNode
    // 完整功能的分页
    vNodePaginationFull: function vNodePaginationFull() {
      var _this2 = this;

      var h = this.$createElement;
      var node = h("el-pagination", {
        "attrs": {
          "layout": "total, sizes, prev, pager, next, jumper",
          "page-sizes": [10, 20, 30, 40],
          "current-page": this.pagination.current,
          "page-size": this.pagination.size,
          "total": this.pagination.total
        },
        "on": {
          "size-change": function sizeChange(size) {
            _this2.pagination.size = size;

            _this2.research();
          },
          "current-change": function currentChange(current) {
            _this2.pagination.current = current;

            _this2.research();
          }
        }
      });
      return node;
    }
  },
  methods: {
    /**
     * @description 分页组件
     * @description 整体更新
     * @description 这是一个常见的通用更新页码方式，适用于一般的查询返回
     */
    paginationUpdate: function paginationUpdate(page) {
      this.paginationUpdateCurrent(page.page_no);
      this.paginationUpdateSize(page.page_size);
      this.paginationUpdateTotal(page.tatal_count);
    },

    /**
     * @description 重置分页
     */
    paginationReset: function paginationReset() {
      this.paginationUpdateCurrent(1);
      this.paginationUpdateSize(10);
      this.paginationUpdateTotal(0);
    },

    /**
     * @description 分页组件
     * @description 更新当前页码
     */
    paginationUpdateCurrent: function paginationUpdateCurrent(value) {
      this.pagination.current = value;
    },

    /**
     * @description 分页组件
     * @description 更新分页大小
     */
    paginationUpdateSize: function paginationUpdateSize(value) {
      this.pagination.size = value;
    },

    /**
     * @description 分页组件
     * @description 更新总页数
     */
    paginationUpdateTotal: function paginationUpdateTotal(value) {
      this.pagination.total = value;
    }
  }
};